import { GET, POST, PUT, DELETE } from './api'

const table = "quiz-response"

export const CreateQuizResponse = async (params) => {
  return await POST(`/${table}`, params, true);
}

export const ReadQuiz = async () => {
  return await GET(`/${table}?populate=*`, true);
}

export const ReadOneQuiz = async (id) => {
  return await GET(`/${table}/${id}`, true);
}

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
}

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
}
